import React from "react";
import "./header.css";
import CTA from "./CTA";
import HeaderSocials from "./HeaderSocials";

import ME from '../../assets/deepak1.png'
const Header = () => {
  return (
    <header id="header" data-aos="zoom-out-up">
      <div className="container header_container">
        <h5>Hello I'm</h5>
        <h1>Desh Deepak Kushwaha</h1>
        <h5 className="text-light"> MERN Stack Developer</h5>
        <CTA />
          <div className="me">
            <img src={ME} alt="Desh Deepak Kushwaha" />
        </div>
        <HeaderSocials />
       
        <a href="#contact" className="scroll_down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
